import { Mui, MuiIcons } from "@osu/react-ui";
import { useGetManageApplicationSidebarProgramQuery } from "../../services/graphql/api";
import LoadingSpinner from "../../Common/components/LoadingSpinner";

const styles = {
    sidebar: {
        borderRight: "1pt solid rgba(0, 0, 0, 0.12)",
        display: "grid",
        gridTemplateRows: "min-content min-content 0fr",
        marginRight: "0.5rem",
        overflow: "hidden",
        transition: "grid-template-rows 200ms",
        Show: {
            gridTemplateRows: "min-content min-content 1fr",
        },
    },
    line: {
        fontSize: { xs: "0.8rem", lg: "0.9rem" },
        fontWeight: "normal",
        lineHeight: "1.5rem",
        textWrap: "nowrap",
    },
};

function Sidebar({ showSidebar, setShowSidebar, reviewerEmployeeId }) {
    function toggleSidebar() { setShowSidebar(!showSidebar); }
    const state = showSidebar ? "Show" : "Hide";

    const { isFetching, data = [] } = useGetManageApplicationSidebarProgramQuery(undefined, { refetchOnMountOrArgChange: true });
    
    return (
        <Mui.Paper sx={{ ...styles.sidebar, ...styles.sidebar[state]}}>
            <SidebarCollapse state={state} toggleSidebar={toggleSidebar} />
            
            <Mui.Divider />
            
            <div style={{ overflow: "hidden" }}>
                <LoadingSpinner isFetching={isFetching} margin={"1rem"} />
                {!isFetching && data?.map?.( data => ( <NumbersSection key={data.sectionLabel} sectionLabel={data.sectionLabel} lines={data.lines} /> ) )}
            </div>
        </Mui.Paper>
    );
}

function SidebarCollapse({ state, toggleSidebar }) {
    const Ele = state === "Expanded" ? MuiIcons.ExpandLess : MuiIcons.ExpandMore;
    const label = ""; // state == "Open" ? "" : "Overview";
    
    return (
        <Mui.Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Mui.Typography aria-label="Collapsible sidebar counts" sx={{ padding: "1rem" }} variant="h2">{label}</Mui.Typography>
            <Mui.IconButton aria-label={state} onClick={toggleSidebar} style={{ position: "relative" }}>
                <Ele style={{ position: "absolute" }} />
            </Mui.IconButton>  
        </Mui.Box>
    );
}

function NumbersSection({ sectionLabel, lines }) {
    if (!lines?.map) { return <></>; }
    return (
        <Mui.Accordion key={sectionLabel} defaultExpanded={true} style={{ margin: "0" }}>
            <Mui.AccordionSummary expandIcon=<MuiIcons.ExpandMore />>{sectionLabel}</Mui.AccordionSummary>
            <Mui.AccordionDetails>
                {lines.map(NumbersLine)}
            </Mui.AccordionDetails>
        </Mui.Accordion>
    );
}

function NumbersLine(data, index) {  
    if (data.divider) { return <Mui.Divider key={index} sx={{ margin: "1rem 0" }} />; }
    if (data.emptyLine) { return <br key={index} style={{ content: " ", display: "block", marginTop: "0.65rem", }} />; }
    
    const stylev = { float: "right" };
    const spacing = "\u00A0".repeat((data.indent ?? 0) * 4);
    const isTopLevel = !data.indent || data.indent === 0;
    const variant = isTopLevel ? "h4" : undefined;
    const colon = isTopLevel ? "" : ":";
    
    return <Mui.Typography key={index} sx={styles.line} variant={variant}>{spacing}{data.label}{colon} <span style={stylev}>{data.value}</span></Mui.Typography>;
}

export default Sidebar;